import { ServiceItemScope } from '~/types/builder.types';

export enum ContractBlockErrors {
    VendorMustFill = 'vendor_required',
    ClientMustFill = 'client_required',
    UnassignedSignature = 'unassigned_signature',
    MissingSignature = 'missing_signature',
    UnSignedSignature = 'unsigned_signature',
    InvalidatedSignature = 'invalidated_signature'
}

export enum PaymentScheduleBlockErrors {
    PaymentsExceedGrandTotal = 'exceed_grand_total',
    PaymentsLessThanGrandTotal = 'less_than_grand_total',
    PercentsExceeded = 'percents_exceed',
    PercentsFallShort = 'percents_fall_short',
    MissingPercentageBasedPayment = 'missing_percentage_based_payment',
    MissingMandatoryItemsForCustomPayment = 'missing_mandatory_items_for_custom_payment',
    PaymentLessThanMinimum = 'payment_less_than_minimum',
    FixedPaymentMoreThanMaximum = 'fixed_payment_more_than_maximum',
    PayInFullPercentageDiscountValidation = 'pay_in_full_percentage_discount_validation',
    PayInFullFixedDiscountValidation = 'pay_in_full_fixed_discount_validation'
}

export enum ServiceSelectionItemBlockErrors {
    MissingTitle = 'missing_title',
    InvalidCustomQuantity = 'invalid_custom_quantity'
}

export type TServiceSelectionItemErrors = {
    hasErrors?: boolean;
    itemTitle?: boolean;
    itemQuantity?: boolean;
    invoiceTitle?: boolean;
    subItemTitle?: boolean;
    subItemQuantity?: boolean;
    emptyDigitalProductLink?: boolean;
    invalidDigitalProductLink?: boolean;
    sessionConfig?: boolean;
};

export type IErrorAdditionalProps = {
    isDontCountSubItemsErrors?: boolean;
    scope?: ServiceItemScope;
    shouldDisplayErrorIconBesideCog?: boolean;
};

export type TServiceSelectionBlockInputValidations = {
    [ServiceSelectionItemBlockErrors.InvalidCustomQuantity]?: boolean;
    [ServiceSelectionItemBlockErrors.MissingTitle]?: boolean;
};
